export default __webpack_public_path__ + "static/media/safe.87a02d56.svg";